import i18n, { supportedLocales } from '@/core/i18n'
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

export function useLang () {
  const browserLang = i18n.global.locale.value ?? 'en'
  const defaultLang = supportedLocales.find(l => l.code === browserLang)!
  const route = useRoute()

  const lang = ref(defaultLang)

  const getLocale = (code?: string) => {
    return supportedLocales.find(l => l.code === (code ?? 'en'))!
  }

  const setLang = () => {
    const globalLang = i18n.global.locale.value
    const locale = supportedLocales.find(l => l.code === (globalLang ?? 'en'))!
    lang.value = locale
  }

  onMounted(setLang)
  watch(route, setLang)
  watch(() => i18n.global.locale.value, setLang)

  return lang
}
